import { AfiliadoCardGrupoSlider } from '../Afiliados/AfiliadoCardGrupoSlider';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import CardButton from '../../@iosper/components/Card/CardButton';
import Grid from '@mui/material/Grid';
import grupoFamiliarImg from '../../assets/images/menu/grupo-familiar.svg';
import OrdenDigitalImg from '../../assets/images/svg/mobile-qrScan.svg';
import ordenImg from '../../assets/images/menu/orden.svg';
import derivacionImg from '../../assets/images/menu/derivacion.svg';
import turnoCalendarImg from '../../assets/images/menu/calendar.svg';
import Title from '../../@iosper/components/Page/Title';
import { AfiliadoCardGrupoSliderMobile } from '../Afiliados/Mobile/AfiliadoCardGrupoSliderMobile';

const Home = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Title autoFocus={false} style={{ display: isMobileScreen ? 'none' : 'initial' }}>
        Inicio
      </Title>

      <Grid container spacing={2}>
        {!isMobileScreen && (
          <Grid item xs={12} sm={6} lg={4}>
            <AfiliadoCardGrupoSlider />
          </Grid>
        )}

        {isMobileScreen && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{
              // 1. Romper el contenedor
              width: '100vw',
              position: 'relative',
              left: '50%',
              transform: 'translateX(calc(-50% + 8px))', // Mejor que margin-left para centrado perfecto
              marginLeft: '0',
              marginRight: '0',
              marginTop: '-4px',
              marginBottom: '16px',
              paddingLeft: '0 !important', // Eliminar padding horizontal para que ocupe todo el ancho
              paddingRight: '0 !important', // Eliminar padding horizontal para que ocupe todo el ancho

              // 2. Mantener el espacio en el flujo del Grid (Evitar que otros suban)
              flexBasis: { xs: '100vw', sm: '100vw', md: '100vw' },
              maxWidth: { xs: '100vw', sm: '100vw', md: '100vw' },
              flexGrow: '0',
              flexShrink: '0',

              // 3. Asegurar altura
              minHeight: 'auto', // O pon el alto específico del carrusel si es necesario
              display: 'block',
              background: theme.palette.gradient.main,
              paddingTop: '16px',
              paddingBottom: '16px',
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '16px',
            }}
          >
            <AfiliadoCardGrupoSliderMobile />
          </Grid>
        )}

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Turno en Sede'}
            description={'Reservá un turno para dirigirte a una sede.'}
            to={'/turno-previo'}
            image={turnoCalendarImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        {isMobileScreen && (
          <Grid item xs={4} sm={4} lg={4}>
            <CardButton
              title={'Orden Electrónica'}
              description={'Escaneá el código Qr para generar tu orden electrónica.'}
              to={'/read-orden'}
              image={OrdenDigitalImg}
              isMobile={isMobileScreen}
            />
          </Grid>
        )}

        {isMobileScreen && (
          <Grid item xs={4} sm={4} lg={4}>
            <CardButton
              title={'Token Farmacia'}
              description={'Generá el token de validación para la farmacia.'}
              to={'/generar-token-farmacia'}
              image={OrdenDigitalImg}
              isMobile={isMobileScreen}
            />
          </Grid>
        )}

        {isMobileScreen && (
          <Grid item xs={4} sm={4} lg={4}>
            <CardButton
              title={'Validar Orden'}
              description={'Escaneá el código Qr para validar tu Orden.'}
              to={'/read-orden-impresa'}
              image={OrdenDigitalImg}
              isMobile={isMobileScreen}
            />
          </Grid>
        )}

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Orden Impresa'}
            description={'Generá ordenes de consulta.'}
            to={'/emitir-orden'}
            image={ordenImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Grupo Familiar'}
            description={'Consultá los datos del grupo familiar.'}
            to={'/grupo-familiar'}
            image={grupoFamiliarImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Derivaciones'}
            description={'Consultá las derivaciones médicas.'}
            to={'/derivaciones'}
            image={derivacionImg}
            isMobile={isMobileScreen}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Home;
